import httpService from './httpService';

const getAll = () => httpService.get('/api/family/all');

export default { getAll };
